import { FormControl as MuiFormControl, FormControlProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export type { FormControlProps };

export const FormControl: React.ComponentType<FormControlProps> = styled(
  MuiFormControl,
)<FormControlProps>(() => ({}));
